import { render, staticRenderFns } from "./packagePriceMgt.vue?vue&type=template&id=7aa69935&scoped=true&"
import script from "./packagePriceMgt.vue?vue&type=script&lang=js&"
export * from "./packagePriceMgt.vue?vue&type=script&lang=js&"
import style0 from "./packagePriceMgt.vue?vue&type=style&index=0&id=7aa69935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa69935",
  null
  
)

export default component.exports